import { NEXT_PUBLIC_IMAGE_URL } from '@/common';
import { IStats } from '@/types';

export const ourDifferences: IStats[] = [
  {
    title: 'Đơn giản',
    icon: `${NEXT_PUBLIC_IMAGE_URL}/image/landing-page/icon_smart.jpg`,
    description: 'Dễ sử dụng, không rối rắm.',
  },
  {
    title: 'Đáng tin cậy',
    icon: `${NEXT_PUBLIC_IMAGE_URL}/image/landing-page/icon_clean.jpg`,
    description:
      'Dựa trên dữ liệu thật & hành vi của hàng triệu triệu người dùng.',
  },
  {
    title: 'Thông minh',
    icon: `${NEXT_PUBLIC_IMAGE_URL}/image/landing-page/icon_trust.jpg`,
    description:
      'Gợi ý những gì hợp nhất với bạn – không đoán mò, với sức mạnh của AI',
  },
];
